<template>

  <Form
    :title="$t('GDPR')"
    :creating="creating"
    :loading="loading">
    <form
      id="profile-form"
      class="shurt-conatiner"
      v-on:submit.prevent="saveProfile(settings)">
      
      <div class="alert alert-secondary">
        <div class="form-group m-0">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="gdpr"
              v-model="settings.gdpr">
            <label
              class="form-check-label"
              for="gdpr">
              {{ $t('Enable GDPR') }}
              </label>
          </div>
          <ValidateMessage :error="validateErrors['settings.gdpr']" />
          <div class="text-muted">{{ $t('View features and settings for GDPR related') }}</div>
        </div>
      </div>

      <div v-if="settings.gdpr">
        <h5 class="my-4">{{ $t('Unsubscribe link') }}</h5>
        <div class="text-muted">{{ $t('(Automatic) Adds a footer with an unsubscribe link to the application confirmation email.') }}</div>
        
        <hr class="my-4">

        <h5 class="my-4">{{ $t('Privacy notice') }}</h5>
        <div class="form-group">
          <!--<label>{{ $t('Privacy notice') }}</label>-->
          <textarea-editable
            editor-model="html"
            :enable-link="true"
            :enable-img="true"
            :maxHeight="280"
            v-model="settings.gdpr_privacy_notice">
            </textarea-editable>
          <ValidateMessage :error="validateErrors['settings.gdpr_privacy_notice']" />
        </div>

        <p v-html="$t('see_Privacy_notice_model')"></p>

        <hr class="my-4">

        <h5 class="my-4">{{ $t('Consent') }}</h5>
        <div>
          <label>{{ $t('Consent request message') }}</label>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              :placeholder="$t('Subject')"
              v-model="settings.gdpr_email_consent_subject">
            <ValidateMessage :error="validateErrors['settings.gdpr_email_consent_subject']" />
          </div>
          <div class="form-group">
            <textarea-editable
              editor-model="html"
              :enable-link="true"
              :enable-img="true"
              :maxHeight="280"
              v-model="settings.gdpr_email_consent_body">
              </textarea-editable>
            <ValidateMessage :error="validateErrors['settings.gdpr_email_consent_body']" />
          </div>
        </div>

        <div class="form-group">
          <label>{{ $t('Consent option on the application form') }}</label>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              id="gdpr_applicant_consent_true"
              :value="true"
              v-model="settings.gdpr_applicant_consent">
            <label
              class="form-check-label"
              for="gdpr_applicant_consent_true">
              {{ $t('Request consent confirmation (Checkbox)') }}
              </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              id="gdpr_applicant_consent_false"
              :value="false"
              v-model="settings.gdpr_applicant_consent">
            <label
              class="form-check-label"
              for="gdpr_applicant_consent_false">
              {{ $t('Display privacy notice only (No checkbox)') }}
              </label>
          </div>
          <ValidateMessage :error="validateErrors['settings.gdpr_applicant_consent']" />
        </div>

        <hr class="my-4">

        <h5 class="my-4">{{ $t('Expiration') }}</h5>
        <div class="form-group">
          <label>{{ $t('Expiration of candidates (In days)') }}</label>
          <input
            type="text"
            class="form-control"
            :placeholder="$t('Days')"
            v-model="settings.gdpr_expiration_days">
          <ValidateMessage :error="validateErrors['settings.gdpr_expiration_days']" />
        </div>
      </div>
      
    </form>
    <template slot="actions">
      <button
        :class="{'box-loading': loading}"
        type="submit"
        form="profile-form"
        class="btn btn-primary">
        {{ $t('Save') }}
        </button>
    </template>
  </Form>

</template>

<script>
import Form from '@/components/Form/Form'
import InputOnePhoto from '@/components/Fields/InputOnePhoto'

export default {
  name: 'AccountProfile',
  components: {
    Form,
    InputOnePhoto
  },
  data () {
    return {
      creating: true,
      loading: false,
      settings: {},
      validateErrors: false
    }
  },
  computed: {
    account () {
      return this.$store.getters.getAccount
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('getAccountSettings', this.account._id)
      .then(result => {
        this.settings = result.settings
        this.creating = false
      })
    },
    /*
    saveProfile
    */
    saveProfile (data) {
      this.loading = true

      this.$store
      .dispatch('updateAccountSettings', {
        _id: this.account._id,
        settings: data
      })
      .then((result) => {
        this.settings = result.settings
        this.loading = false
        this.validateErrors = {}
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountGDPR.vue